import cf from './cf';
import i1zv7 from './i1zv7_20220415a';

export default class i1zv7a extends i1zv7 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: '月間予約登録',
      class: 'i1zv7a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
